import get from 'lodash/get';

export const getValues = props => {
  const isShippingEstimated = get(props, 'summary.totals_v2.shipping_estimated', false);
  return {
    itemTotal: props.summary.totals.items,
    discountCode: props.summary.promoCode,
    discountAmount: props.summary.totals.discount,
    discountedTotal: isShippingEstimated && props.estimatedShippingLabel
      ? props.summary.totals_v2.order
      : props.summary.totals.order,
    estimatedShipping: isShippingEstimated ? props.summary.totals_v2.shipping : props.summary.totals.shipping,
    salesTax: get(props, 'summary.totals_v2.tax') || {},
    storeCredit: get(props, 'summary.store_credits') || {},
  };
};



// WEBPACK FOOTER //
// ./src/client/js/view/components/CartSummary/helpers.js